import { Content } from '@elizaos/core';
import {
  GetPortfolioContent,
  GetTokenPriceContent,
  GetNFTsContent,
  GetPriceChartDataContent,
  GetVolumeAndLiquidityContent,
  GetPortfolioPerformanceContent,
} from './index';
import {
  GetNetworkInfoContent,
  GetCrossChainAssetsContent,
  GetGasPriceContent,
  GetBlockExplorerContent,
} from './network';
import { TransactionHistoryContent, TransactionDetailsContent } from './transaction';
import { AccountInfoContent } from './account';
import { GetAppPositionsContent } from './defi';
import { GetHistoricalPriceContent } from './market';

export function isGetPortfolioContent(content: Content): content is GetPortfolioContent {
  return (
    typeof content === 'object' &&
    content !== null &&
    'address' in content &&
    typeof content.address === 'string'
  );
}

export function isGetTokenPriceContent(content: Content): content is GetTokenPriceContent {
  return (
    typeof content === 'object' &&
    content !== null &&
    'symbol' in content &&
    typeof content.symbol === 'string'
  );
}

export function isGetNFTsContent(content: Content): content is GetNFTsContent {
  return (
    typeof content === 'object' &&
    content !== null &&
    'address' in content &&
    typeof content.address === 'string'
  );
}

export function isGetNetworkInfoContent(content: Content): content is GetNetworkInfoContent {
  return (
    typeof content === 'object' &&
    content !== null &&
    (('networkId' in content && typeof content.networkId === 'string') ||
      ('chainId' in content &&
        (typeof content.chainId === 'number' || typeof content.chainId === 'string')))
  );
}

export function isGetCrossChainAssetsContent(
  content: Content
): content is GetCrossChainAssetsContent {
  return (
    typeof content === 'object' &&
    content !== null &&
    'address' in content &&
    typeof content.address === 'string'
  );
}

export function isGetGasPriceContent(content: Content): content is GetGasPriceContent {
  return (
    typeof content === 'object' &&
    content !== null &&
    (('networkId' in content && typeof content.networkId === 'string') ||
      ('chainId' in content &&
        (typeof content.chainId === 'number' || typeof content.chainId === 'string')))
  );
}

export function isGetBlockExplorerContent(content: Content): content is GetBlockExplorerContent {
  return (
    typeof content === 'object' &&
    content !== null &&
    (('networkId' in content && typeof content.networkId === 'string') ||
      ('chainId' in content &&
        (typeof content.chainId === 'number' || typeof content.chainId === 'string')))
  );
}

export function isGetTransactionHistoryContent(
  content: Content
): content is TransactionHistoryContent {
  return (
    typeof content === 'object' &&
    content !== null &&
    'address' in content &&
    typeof content.address === 'string'
  );
}

export function isGetTransactionDetailsContent(
  content: Content
): content is TransactionDetailsContent {
  return (
    typeof content === 'object' &&
    content !== null &&
    'transactionHash' in content &&
    typeof content.transactionHash === 'string'
  );
}

export function isGetAccountInfoContent(content: Content): content is AccountInfoContent {
  return (
    typeof content === 'object' &&
    content !== null &&
    'address' in content &&
    typeof content.address === 'string'
  );
}

export function isGetAppPositionsContent(content: Content): content is GetAppPositionsContent {
  return (
    typeof content === 'object' &&
    content !== null &&
    'address' in content &&
    typeof content.address === 'string'
  );
}

export function isGetHistoricalPriceContent(
  content: Content
): content is GetHistoricalPriceContent {
  return (
    typeof content === 'object' &&
    content !== null &&
    'symbol' in content &&
    typeof content.symbol === 'string'
  );
}

export function isGetPriceChartDataContent(content: Content): content is GetPriceChartDataContent {
  return (
    typeof content === 'object' &&
    content !== null &&
    'symbol' in content &&
    typeof content.symbol === 'string'
  );
}

export function isGetVolumeAndLiquidityContent(
  content: Content
): content is GetVolumeAndLiquidityContent {
  return typeof content === 'object' && content !== null;
}

export function isGetPortfolioPerformanceContent(
  content: Content
): content is GetPortfolioPerformanceContent {
  return (
    typeof content === 'object' &&
    content !== null &&
    'address' in content &&
    typeof content.address === 'string'
  );
}
